import React from 'react';
import {ClusterIconStyle} from '@google/markerclustererplus';

import MapMarkerIcon from '../../components/map-markers/map-marker/map-marker';
import ClusterMarkerIcon from '../../components/map-markers/cluster-marker/cluster-marker';

import {
  markerSize,
  selectedMarkerSize,
  clusterMarkerSize
} from '../../../constants/markers';

import {checkIsBeforeYear1945} from '../../libs/check-before-year-1945';
import {encodeSvgToDataUrl} from '../../libs/encode-svg';

/**
 * Function to get the work of arts marker icon
 */
export const getMarkerIcon = (
  year: string,
  isSelected: boolean
): google.maps.Icon | null => {
  const isBeforeYear1945 = checkIsBeforeYear1945(year);

  if (isBeforeYear1945 === null) {
    return null;
  }

  const size = isSelected ? selectedMarkerSize : markerSize;
  const anchor: [number, number] = [size[0] / 2, size[1] * 0.923];

  return {
    anchor: new google.maps.Point(...anchor),
    scaledSize: new google.maps.Size(...size),
    url: encodeSvgToDataUrl(
      <MapMarkerIcon
        isBeforeYear1945={isBeforeYear1945}
        isSelected={isSelected}
      />
    )
  };
};

/**
 * Function to get the cluster marker icon
 */
export const getClusterMarkerIcon = (
  isBeforeYear1945: boolean | null
): ClusterIconStyle => {
  const width = clusterMarkerSize[0];
  const height = clusterMarkerSize[1];

  return {
    url: encodeSvgToDataUrl(
      <ClusterMarkerIcon isBeforeYear1945={isBeforeYear1945} />
    ),
    width,
    height,
    anchorIcon: [height * 0.923, width / 2], // [yoffset, xoffset]
    fontFamily: 'var(--body-font-family)',
    textSize: 15,
    textColor: 'var(--dhm-map-black)'
  };
};
